import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const RightOfAccessTermsOfUse = () => {
  const { classes } = useTOCStyles();

  return (
    <div>
      <SectionHeader title="Right of Access" />
      <ol start={10}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`SEAB grant you a non-exclusive, limited, revocable, non-sub-licensable and ` +
              `non-transferable right to access or use the Contents for personal and non-commercial use ` +
              `only. `}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`SEAB reserves all rights to deny or restrict access to this Web Site to any particular ` +
              `person, or to block access from a particular Internet address to this Web Site, at any time, ` +
              `without ascribing any reasons whatsoever.`}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`If you access and use the Web Site on behalf of an Organisation, you represent and warrant ` +
              `that you have been authorised:`}
          </Typography>
          <ol start={1} type="a">
            <li>
              <Typography variant="body1">
                to access and use the Web Site for your personal or non-commercial use only; and
              </Typography>
            </li>
            <li>
              <Typography variant="body1">to bind the Organisation to these Terms.</Typography>
            </li>
          </ol>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            You hereby agree that you will not directly or indirectly:
          </Typography>
          <ol start={1} type="a">
            <li>
              <Typography variant="body1">
                {` whether in whole or in part, modify, reverse-engineer, decompile, adapt, publish, ` +
                  `redistribute, sublicense or interfere with or intercept any transaction which is part ` +
                  `of the Web Site (including but not limited to authentication and password issuance/reset services) ` +
                  `without our prior written consent;`}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {`use the Web Site or the Contents for any commercial purpose (including commercial ` +
                  `communications), including but not limited to renting, selling, leasing or directly or ` +
                  `indirectly charging others for access or use of the Web Site or the Contents or any part thereof;`}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {`reproduce or make any copies of the Web Site or the Contents, including any software ` +
                  `therein except with our prior written consent;`}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                remove, circumvent, impair, bypass, disable or otherwise interfere with
                security-related features of the Web Site, including any feature that:
              </Typography>
              <ol type="i">
                <li>
                  <Typography variant="body1">
                    prevents or restricts access or use of any particular functionality or feature
                    of the Web Site;
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    prevents or restricts the access or use of any Account; and/or
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    prevents or restricts the access to, or use of any Contents that is made
                    available or accessible through the Web Site;
                  </Typography>
                </li>
              </ol>
            </li>
            <li>
              <Typography variant="body1">
                access, log into or use any Account that is not yours, or which you are not validly
                authorised to access, log into or use;
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                misrepresent or make false or misleading claims regarding the Web Site or the
                Contents;
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                use the Web Site or the Contents for any illegal activity, unlawful purpose or for
                any purpose prohibited by these Terms or in breach of these Terms;
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                use any device, software, exploits, or routine, including any virus, Trojan horse,
                worm, time bomb, robot, spider, data-mining or data scraping tool or cancel bot
                intended to damage or interfere with the proper operation of the Web Site and or to
                intercept or expropriate any Contents or personal data from the Web Site;
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                transmit or upload viruses, worms, defects, Trojan horses, malware or any other
                items that may introduce security vulnerabilities to or harm the Web Site or the
                Devices of other persons;
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                use the Web Site in any manner that could damage, disrupt, disable, overburden, or
                impair the operation of the Web Site; interfere with any other person’s access or
                use of the Web Site; or impose an unreasonable or disproportionately large load on
                the systems and servers used in the provision of the Web Site;
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                in the course of using the Web Site, upload, post or transmit any Contents of any
                type that:
              </Typography>
              <ol type="i">
                <li>
                  <Typography variant="body1">
                    violates any applicable law, statute, rule or regulation;
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    is false, offensive, defamatory, inaccurate, misleading or fraudulent; and/or
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    infringes or violates any rights of any person;
                  </Typography>
                </li>
              </ol>
            </li>
            <li>
              <Typography variant="body1">
                use the Web Site to access data not intended for you; and
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                solicit passwords or personal data from any other person or entity for purposes of
                accessing or using the Web Site.
              </Typography>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};

export default RightOfAccessTermsOfUse;
